<div v-bind:class="useClassName">
  <a
    @click="uploadOnPreview(propsData.code)"
    v-if="getAttribute('previewFile') && getAttribute('showRearrange')"
  >
    <img :id="getId" :src="getAttribute('previewFile') + '?v=' + getUploadedFileUniqueVersion()" />
  </a>
  <a
    :data-fancybox="'gallery' + propsData.refId"
    :href="getAttribute('previewFileLink')"
    v-if="getAttribute('previewFile') && !getAttribute('showRearrange')"
  >
    <img :id="getId" :src="getAttribute('previewFile') + '?v=' + getUploadedFileUniqueVersion()" />
  </a>
 </div>